import Constants from 'expo-constants'

// OIDC config from env (app.config.ts → extra). Empty issuer ⇒ dev-fallback mode.
const extra = Constants.expoConfig?.extra ?? {}

export const oidcConfig = {
  issuer: (extra.oidcIssuer as string) ?? '',
  clientId: (extra.oidcClientId as string) ?? 'as-life-web',
  scopes: ['openid', 'profile', 'email'],
}

export const devUserEmail = (extra.devUserEmail as string) ?? ''

/**
 * Login flow for the sign-in screen:
 *  - 'pkce'     — browser redirect (Authorization Code + PKCE) — the OIDC target.
 *  - 'password' — in-app ROPC (Direct Access Grant). Default, kept until the Keycloak
 *                 client `as-life-web` has Standard Flow + redirect URI configured.
 * Flip via EXPO_PUBLIC_AUTH_FLOW=pkce once Keycloak is ready (see security note).
 */
export const authFlow: 'pkce' | 'password' =
  (extra.authFlow as string) === 'pkce' ? 'pkce' : 'password'

/** Real OIDC mode is on only when an issuer is configured. */
export const authEnabled = !!oidcConfig.issuer

/**
 * Кабинет внешних (поставщики, турагенты) — ОТДЕЛЬНЫЙ realm Keycloak и отдельный клиент.
 * Вход туда только браузерным флоу: прямой грант у клиента кабинета выключен сознательно,
 * потому что внешнему нужны required actions (временный пароль, смена пароля), а они ROPC
 * ломают. Пусто → кабинет в этом сборке выключен, его маршруты не показываем.
 */
export const cabinetOidcConfig = {
  issuer: (extra.cabinetOidcIssuer as string) ?? '',
  clientId: (extra.cabinetOidcClientId as string) ?? 'as-life-cabinet',
  scopes: ['openid', 'profile', 'email'],
}

export const cabinetEnabled = !!cabinetOidcConfig.issuer
